document.addEventListener('turbo:load', () => {
  const run = document.getElementsByClassName('curriculum_selector');

  // resetUI - arguments are passed along from data atttributes on anchor tags
  // with the classname 'opener'
  // close - remove visibility from closeTargets
  // from - remove selected from resetTargets
  const resetUI = (from, close) => {
    const closeTargets = close.split(' ');
    const resetTargets = from.split(' ');

    Array.from(resetTargets).forEach(target => {
      const toDeselect = document.querySelectorAll('.' + target + ' .selected');

      Array.from(toDeselect).forEach(item => {
        item.classList.remove('selected');
      });
    });

    Array.from(closeTargets).forEach(target => {
      const toClose = document.getElementsByClassName(target);

      Array.from(toClose).forEach(item => {
        item.classList.remove('show');

        const toDeselect = item.querySelectorAll('.selected');

        Array.from(toDeselect).forEach(item => {
          item.classList.remove('selected');
        });
      });
    });
  };

  // If we are on a page with the curriculum selector
  if (run.length > 0) {
    // All anchor tags with the class name opener
    const openers = document.getElementsByClassName('opener');

    // Add a click event
    Array.from(openers).forEach(opener => {
      opener.addEventListener('click', (e) => {
        e.preventDefault();

        const selected = opener.classList.contains('selected');

        // Reset the UI - remove visibility and selected from elements
        resetUI(opener.dataset.from, opener.dataset.close);

        // Add the correct selected and visible classes to correct elements
        const toOpen = document.getElementsByClassName(opener.dataset.open);
        const toSelect = document.getElementsByClassName(opener.dataset.opener);

        // On mobile we want to close an open item when the close-self
        // attribute is set and also it contains the class selected before the
        // reset
        if(opener.dataset.closeSelf && selected) {
          Array.from(toSelect).forEach(selected => {
            selected.classList.remove('selected')
          });

          Array.from(toOpen).forEach(open => {
            open.classList.remove('show')
          });
        } else {
          // Deselect and set to invisible
          Array.from(toSelect).forEach(selected => {
            selected.classList.add('selected')
          });

          Array.from(toOpen).forEach(open => {
            open.classList.add('show')
          });
        }

        // Change the breadcrumbs
        const topicBreadcrumb = document.querySelector('.topic-area');

        if (topicBreadcrumb) {
          topicBreadcrumb.innerHTML = opener.dataset.breadcrumb || '';
        }

        const gradeAreaBreadcrumb = document.querySelector('.grade-area');

        if (gradeAreaBreadcrumb) {
          gradeAreaBreadcrumb.innerHTML = opener.dataset.gradearea || '';
        }

        // If the opener link has the data attribute jump-top (this is only on
        // mobile for the area opener) we will jump to the top of the page.
        const jumpTop = opener.dataset.jumpTop || null;

        if(jumpTop) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
      });
    });
  }
});
